import React, { useContext, useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import axios from 'axios';
import '../../../../assets/css/user/contact/getInTouch/GetIntouch.css';
import AppContext from '../../../../context/AppContext.js';

const GetInTouch = () => {
  const {baseUrl }  = useContext(AppContext);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const createTicket = () => {
    setLoading(true);
    setSuccessMessage('');

    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('subject', subject);
    formData.append('message', message);

    axios
      .post(`${baseUrl}/Customer/ContactForm/createTicket`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => {
        console.log('Response:', response.data);
        if (response.data.success === true) {
          setSuccessMessage("Thank you for contacting us! We'll get back to you soon.");
          setName('');
          setEmail('');
          setSubject('');
          setMessage('');
          setTimeout(() => setSuccessMessage(''), 5000);
        } else {
          alert(response.data.message || 'Something went wrong.');
        }
      })
      .catch((error) => {
        console.log('Error:', error);
        alert('Something went wrong. Please try again later.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      title: 'EMAIL ADDRESS',
      detail: 'support@smartagrirent.com',
    },
    {
      icon: <FaPhoneAlt />,
      title: 'PHONE NUMBER',
      detail: '+92 300 1234567 – Support Team',
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'OUR ADDRESS',
      detail: 'Gujranwala, Punjab, Pakistan',
    },
  ];

  return (
    <section className="contact-section">
      <Container>
        <Row>
          {/* Left Side - Contact Info */}
          <Col lg={5} md={12} className="contact-info-col">
            <div className="contact-info-wrapper">
              <h2 className="contact-heading">
                GET IN TOUCH
                <div className="heading-underline"></div>
              </h2>

              <p className="contact-description">
                We are always ready to support farmers and equipment users. Whether you need help
                with equipment rental, maintenance services, or general inquiries, feel free to
                reach out to SmartAgri Rent. Our team will respond quickly to provide the best
                possible assistance.
              </p>

              <div className="contact-details">
                {contactInfo.map((item, index) => (
                  <div key={index} className="inf-contact-item">
                    <div className="contact-contact-icon-wrapper">
                      <div className="contact-contact-icon">{item.icon}</div>
                    </div>
                    <div className="contact-text">
                      <h4 className="contact-title">{item.title}</h4>
                      <p className="contact-detail">{item.detail}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* Right Side - Contact Form */}
          <Col lg={7} md={12} className="contact-form-col">
            <div className="contact-form-wrapper">

              {successMessage && (
                <Alert variant="success" className="success-message">
                  {successMessage}
                </Alert>
              )}

              <Form>
                <Row>
                  <Col md={6} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="form-input"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        type="email"
                        placeholder="Your Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-input"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        className="form-input"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        as="textarea"
                        rows={6}
                        placeholder="your Message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className="form-textarea"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Button
                      type="button"
                      className="submit-btn"
                      disabled={loading}
                      onClick={createTicket}
                    >
                      {loading ? 'SENDING...' : 'SEND'}
                    </Button>
                  </Col>
                </Row>
              </Form>

            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GetInTouch;